import { render, staticRenderFns } from "./organization-policy-group-form.vue?vue&type=template&id=35c1c90a"
import script from "./organization-policy-group-form.vue?vue&type=script&lang=js"
export * from "./organization-policy-group-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports